import { Page } from "../enums/Page";
import { css, html } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";

const styles: string = css`
    .container {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
    button {
        padding: 1rem 2rem;
        cursor: pointer;
        background-color: #e1d4ba;
        color: black;
        font-family: "Onesize";
        font-size: 1.5rem;
        border: 0;
    }
    button:hover {
        background-color: #716a5b;
        color: white;
    }
`;

export class TipComponent extends HTMLElement {
    private readonly _gameEventService: GameEventService = new GameEventService();

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        if (!this.shadowRoot) {
            return;
        }

        const element: HTMLElement = html`
            <div class="container">
                <img src="/assets/img/rooms/layers/hint3.png" alt = "tip">
                <button id = "closeTip">X</button>
            </div>
        `;
        const btn: HTMLButtonElement = element.querySelector("#closeTip")!;

        btn.addEventListener("click", () => this._gameEventService.switchPage(Page.Canvas));

        this.shadowRoot.replaceChildren(
            html`<style>${styles}</style>`,
            element
        );
    }
}
